"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableRowMenu = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const row_menu_html_1 = __importDefault(require("./row-menu.html"));
const constants = __importStar(require("./constants"));
const row_model_1 = require("./model/row-model");
const column_1 = require("./column");
let ItpDataTableRowMenu = class ItpDataTableRowMenu extends vue_1.default {
    model;
    row;
    col;
    invalid;
    data() {
        return {
            ...constants,
            mouseOver: false
        };
    }
    get pendingOp() {
        return this.row.isSaving && !this.row.isDeleting;
    }
    get saveIconClass() {
        return this.invalid ? 'text-muted' : 'text-success';
    }
};
exports.ItpDataTableRowMenu = ItpDataTableRowMenu;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", row_model_1.RowModel)
], ItpDataTableRowMenu.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", column_1.ColumnDefinition)
], ItpDataTableRowMenu.prototype, "col", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRowMenu.prototype, "invalid", void 0);
exports.ItpDataTableRowMenu = ItpDataTableRowMenu = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: row_menu_html_1.default,
        inject: {
            model: 'model'
        }
    })
], ItpDataTableRowMenu);
//# sourceMappingURL=row-menu.js.map